export default __webpack_public_path__ + "static/media/icon-calendar-inverted.1d877e87.svg";